import { Component, inject, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import {  isPlatformBrowser } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { ChatCallCenterComponent } from "../../shared/chat-call-center/chat-call-center.component";
import { AuthService } from '../../core/service/auth.service';
import { PushNotificationDemoComponent } from "../../shared/components/push-notification-demo/push-notification-demo.component";
import { FirebaseMessagingService } from '../../core/service/firebase-messaging.service';
import { UpdateBalanceFirebaseHandler } from '../../core/handlers/update-balance-firebase.handler';

@Component({
  selector: 'features-index',
  imports: [HeaderComponent, RouterOutlet, FooterComponent, ChatCallCenterComponent, PushNotificationDemoComponent],
  templateUrl: './index.component.html',
  styleUrl: './index.component.css',
  standalone: true
})
export class IndexComponent implements OnInit {
  authenticate: boolean = false;
  private _updateBalanceFirebaseHandler = inject(UpdateBalanceFirebaseHandler);
  constructor(private authService: AuthService,
    private firebaseMessagingService: FirebaseMessagingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.authenticate = this.authService.isLoggedIn();
    if (this.authenticate) {
      if (isPlatformBrowser(this.platformId)) {
        this.firebaseMessagingService.installFVMServiceWorker();
      }
    } else {

    }
  }
  ngOnInit() {
    this.firebaseMessagingService.getRechargeNotifications().subscribe((notification) => {
      this._updateBalanceFirebaseHandler.updateBalance();
    });
  }
}
